import axios from "axios";

import { apiLink } from "../env";

const stripeHelpers = {

    fetchClientSecret: async (email, plan) => {

        const secretRes = await axios.post(`${apiLink}/zs/checkout/handle_create_subscription_payment_intent`, { email, plan })

        return secretRes.data
    
    }

}

export default stripeHelpers;